import type { ContractDTO } from "@/models/dtos/contract-dto";
import type { CreateContractRequest } from "@/models/requests/create-contract-request";
import { sortByName } from "@/utils/sort-utils";
import { http } from "./http";
import type { UpdateContractRequest } from "@/models/requests/update-contract-request";
import type { PhoneContractDTO } from "@/models/dtos/phone-contract-dto";
import { notificationsService } from "./notifications-service";
import { authService } from "@/services/auth-service";

class ContractsService {
  async getContracts(query?: Record<string, unknown>) {
    const authHeader = await authService.getAuthHeader();
    const contracts = await http
      .auth(authHeader)
      .url("/contracts")
      .query(query ?? {})
      .get()
      .fetchError((err) => notificationsService.error(err))
      .json<ContractDTO[]>();

    return sortByName(contracts);
  }

  async getContract(contractId: string | number) {
    const authHeader = await authService.getAuthHeader();
    return http
      .auth(authHeader)
      .url(`/contracts/${contractId}`)
      .get()
      .fetchError((err) => notificationsService.error(err))
      .json<ContractDTO>();
  }

  async getContractByEppsusId(eppsusId: string | number) {
    const authHeader = await authService.getAuthHeader();
    return http
      .auth(authHeader)
      .url(`/contracts/eppsus/${eppsusId}`)
      .get()
      .fetchError((err) => notificationsService.error(err))
      .json<ContractDTO>();
  }

  async getPhoneContracts() {
    const authHeader = await authService.getAuthHeader();
    return http
      .auth(authHeader)
      .url(`/contracts/phone`)
      .get()
      .fetchError((err) => notificationsService.error(err))
      .json<PhoneContractDTO[]>();
  }

  async getPhoneContract(contractId: string | number) {
    const authHeader = await authService.getAuthHeader();
    return http
      .auth(authHeader)
      .url(`/contracts/${contractId}/phone`)
      .get()
      .fetchError((err) => notificationsService.error(err))
      .json<PhoneContractDTO>();
  }

  async createCustomer(request: CreateContractRequest): Promise<ContractDTO> {
    const authHeader = await authService.getAuthHeader();
    return http
      .auth(authHeader)
      .url("/contracts")
      .post(request)
      .fetchError((err) => notificationsService.error(err))
      .json<ContractDTO>();
  }

  async updateContract(
    contractId: string | number,
    request: UpdateContractRequest,
  ): Promise<ContractDTO> {
    const authHeader = await authService.getAuthHeader();
    return http
      .auth(authHeader)
      .url(`/contracts/${contractId}`)
      .put(request)
      .fetchError((err) => notificationsService.error(err))
      .json<ContractDTO>();
  }
}

export const contractsService = new ContractsService();
